import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, Input } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BootstrapMarketoService } from 'lib/services/bootstrap/bootstrap-marketo.service';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { CategoryService } from 'lib/services/category/category.service';
import { RouterService } from 'lib/services/router.service';
import { WebpService } from 'lib/services/webp.service';
import { SpecialModule } from 'lib/modules/special.module';
import { ButtonComponent } from '../../../../../components/button/button.component';

@Component({
    selector: 'cms-partial-category-top-hero-banner',
    templateUrl: './category-top-banner.component.html',
    styleUrls: ['./category-top-banner.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, SpecialModule, ButtonComponent],
})
export class CategoryTopBannerComponent extends CmsPartialComponentClass {
    @Input() bannerRow: any;
    @Input() dataUrl: string;
    @Input() dataTitle: string;
    @Input() solutionID: string;
    getWebpImg: (src: string) => string;

    constructor(
        @Inject('environment') environment: any,
        breakpointObserver: BreakpointObserver,
        routerService: RouterService,
        public bootstrapMarketoService: BootstrapMarketoService,
        webpService: WebpService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                breakpointObserver,
                bootstrapMarketoService,
                environment,
                routerService,
                location,
                categoryService,
                webpService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }
}
